import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

interface SplashScreenProps {
  isLoading: boolean;
  message?: string;
  onComplete?: () => void;
}

/**
 * Componente SplashScreen con diseño minimalista elegante
 * Muestra el logo de Cornellà con animaciones suaves durante la carga
 */
const SplashScreen: React.FC<SplashScreenProps> = ({ 
  isLoading, 
  message = "Cargando CorneApp...", 
  onComplete 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [logoLoaded, setLogoLoaded] = useState(false);

  useEffect(() => {
    if (!isLoading && logoLoaded) {
      // Esperar un poco antes de ocultar para suavizar la transición
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          onComplete?.();
        }, 500); // Tiempo para la animación de salida
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [isLoading, logoLoaded, onComplete]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${!isLoading ? 'splash-screen--fade-out' : ''}`}>
      <div className="splash-content">
        {/* Logo con animación fade-in */}
        <div className={`splash-logo ${logoLoaded ? 'splash-logo--loaded' : ''}`}>
          <img 
            src="/cornella.png" 
            alt="Cornellà Logo" 
            onLoad={() => setLogoLoaded(true)}
            onError={() => setLogoLoaded(true)} // Continuar aunque falle la carga
          />
        </div>
        
        {/* Texto de la app */}
        <div className={`splash-title ${logoLoaded ? 'splash-title--loaded' : ''}`}>
          <h1>CorneApp</h1>
        </div>
        
        {/* Mensaje de estado */}
        <div className={`splash-message ${logoLoaded ? 'splash-message--loaded' : ''}`}>
          <p>{message}</p>
        </div>
        
        {/* Spinner discreto solo durante verificación */}
        {isLoading && message.includes('Verificando') && (
          <div className={`splash-spinner ${logoLoaded ? 'splash-spinner--loaded' : ''}`}>
            <div className="spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SplashScreen;